export const getPadTitle = (padId: string) => {
    return padId.split("$")[1].replaceAll("_", " ");
};
